module.exports = __webpack_public_path__ + "static/media/2_POA_uchastie_OSA_obrazec25_09_2015.ad696690.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/2_POA_uchastie_OSA_obrazec25_09_2015.pdf
// module id = 178
// module chunks = 0